

























































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import {
  IInventoryAdvancePayment,
  IInventoryAdvancePaymentAttachment
} from '@/models';
import { ISystemError } from '@/models/error/error.types';

import mixins from '@/utils/mixins';
import snackbar from '@/mixins/snackbar';
import { createFile, setErrorFromAxiosError } from '@/utils/helpers';

import InventoryAdvancePaymentAddAttachmentsFormDialog from './InventoryAdvancePaymentAddAttachmentsFormDialog.vue';
import ConfirmationDialog from '../common/ConfirmationDialog.vue';

const baseMixins = mixins(snackbar);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    addAttachmentsFormDialog: InstanceType<
      typeof InventoryAdvancePaymentAddAttachmentsFormDialog
    >;
  };
}

export default baseMixins.extend({
  name: 'InventoryAdvancePaymentAttachmentsListItem',
  components: {
    ConfirmationDialog
  },

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>,
      required: true
    },

    attachment: {
      type: Object as PropType<IInventoryAdvancePaymentAttachment>,
      required: true
    }
  },

  data() {
    return {
      deleteAttachmentDialog: false,
      attachmentError: null as ISystemError | null
    };
  },

  methods: {
    ...mapActions({
      deleteInventoryAdvancePaymentAttachment:
        'inventoryAdvancePayment/deleteInventoryAdvancePaymentAttachment'
    }),

    clearErrors() {
      this.attachmentError = null;
    },

    downloadAttachment(attachment: IInventoryAdvancePaymentAttachment) {
      this.clearErrors();
      this.$services.fileLoader
        .downloadFile(attachment.file as string)
        .then(data => {
          createFile(data, attachment.filename!);
        })
        .then(() => {
          this.createSnack({
            color: 'success darken-1',
            type: 'download',
            right: true,
            useBtn: false,
            msg: `Downloaded file: '${attachment.filename}'`,
            btnText: 'Close'
          });
        })
        .catch(error => {
          this.attachmentError = setErrorFromAxiosError(error);
        });
    },

    closeDeleteAttachmentDialog() {
      this.deleteAttachmentDialog = false;
    },

    removeAttachment(attachment: IInventoryAdvancePaymentAttachment) {
      this.clearErrors();
      this.deleteInventoryAdvancePaymentAttachment({
        inventoryAdvancePaymentId: this.inventoryAdvancePayment.id,
        attachmentId: attachment.id
      })
        .then(() => {
          this.inventoryAdvancePayment.detachFile(attachment.file as File);
          this.closeDeleteAttachmentDialog();
          this.createSnack({
            color: '',
            right: true,
            useBtn: false,
            msg: 'Successfully removed attachment',
            btnText: 'Close'
          });
        })
        .catch(error => {
          this.attachmentError = setErrorFromAxiosError(error);
        });
    }
  }
});
